// @vendors
const React = require('react');

// @commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const WizardError = require('components/commons/wizardError/wizardError');

// @ utilities
const { changeBiocatchContext } = require("utilities/biocatch");

// @constants
const { UNSUCCESFUL_OPERATION } = require("constants/biocatch");

const EcommerceKeyCheckError = () => {
    changeBiocatchContext(UNSUCCESFUL_OPERATION);
    const title = formatText('eCommerceCheckError-errorTitle');
    const goBackButtonLabel = formatText('eCommerceCheckError-backToKeys')
    const linkToKeys = `/myprofile/keys`;
    const goBackButton = {
        label: goBackButtonLabel,
        url: linkToKeys
    };

    return (
        <div className="col-xs-12 col-md-12">
            <WizardError errorMessage={title} mainButton={goBackButton}>
                <section className="row">
                    <div className="col-xs-12">
                        <FormattedText
                            value="eCommerceCheckError-errorMessage"
                        />
                    </div>
                </section>
            </WizardError>
        </div>
    )
};

module.exports = EcommerceKeyCheckError;